// frontend/src/components/AuthRequiredModal.tsx
import React from 'react';
import ReactDOM from 'react-dom';

interface AuthRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOk: () => void;
}

/**
 * Generic modal that appears before LoginModal to inform users
 * why they need to sign in for a specific feature.
 *
 * This provides a two-step flow:
 * 1. AuthRequiredModal: "You need to sign in" (context)
 * 2. LoginModal: "Here's how to sign in" (action)
 */
export const AuthRequiredModal: React.FC<AuthRequiredModalProps> = ({
  isOpen,
  onClose,
  onOk
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="auth-required-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Sign In Required</h2>
          <button
            className="close-button"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="auth-required-icon">
            ✨
          </div>

          <p className="auth-required-message">
            You need to sign in or create an account to use this feature. It only takes a minute!
          </p>

          <p className="auth-required-submessage">
            Save your work, track your progress, and access from anywhere.
          </p>
        </div>

        <div className="modal-footer">
          <button className="btn-ok" onClick={onOk}>
            OK
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
